import React from "react";
import SplitPie from "./SplitPie";
import "./SplitLegend.scss";

// Key for the item donuts, drawn with the real SplitPie so it matches what's
// on the items exactly (each example is an item split 2 ways).
const SplitLegend: React.FC = () => (
  <div className="split-legend">
    <span className="legend-entry">
      <SplitPie splits={2} claimed={0} mine={0} size={22} />
      unselected
    </span>
    <span className="legend-entry">
      <SplitPie splits={2} claimed={1} mine={0} size={22} />
      selected by others
    </span>
    <span className="legend-entry">
      <SplitPie splits={2} claimed={1} mine={1} size={22} />
      your selection
    </span>
  </div>
);

export default SplitLegend;
